export const validState = {
  type: undefined,
  message: undefined,
  isValid: true
};
export function requiredErrorState(label) {
  return {
    type: 'error',
    message: label ? `${label} is required` : 'Field is required',
    isValid: false
  };
}
export function errorStateWithMessage(message) {
  return {
    type: 'error',
    message,
    isValid: false
  };
}
export function searchableSelectInvalidSelectionState(selection) {
  return {
    type: 'error',
    message: `'${selection}' is an invalid selection`,
    isValid: false
  };
}
export function invalidInputState(label, timePicker) {
  return {
    isValid: false,
    message: timePicker ? 'Please enter a valid time' : label ? `${label} is invalid` : 'Field is invalid',
    type: 'error'
  };
}
export function invalidInputStateWithReason(label, reason) {
  return {
    type: 'error',
    message: label ? `${label} input is invalid.  ${reason}` : `Field is invalid. ${reason}`,
    isValid: false
  };
}
export const unTriggeredRuleResult = {
  triggered: false,
  validationState: {
    ...validState
  }
};